export const ACTIONS:any = {
	DELETE: 'delete',
	MARK_AS_SENT: 'sent',
	MARK_AS_APPROVED: 'approved',
	MARK_AS_REJECTED: 'rejected',
	EMAIL: 'email',
	WHATSAPP: `whatsapp`,
	CONVERT_TO_PROPOSAL: 'convert-to-proposal',
	CONVERT_TO_INVOICE: 'convert-to-invoice'
}

